import * as z from 'zod';

export const CollaboratorSchema = z.object({
  id: z.number(),
  full_name: z.string(),
  is_active: z.boolean(),
});

export const UpdateCollaboratorsPayloadSchema = z.object({
  collaborators: z.array(z.number()),
  comment: z.string().min(1),
});

export type Collaborator = z.infer<typeof CollaboratorSchema>;
export type UpdateCollaboratorsPayload = z.infer<typeof UpdateCollaboratorsPayloadSchema>;
